/// ///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2026 CONQUER INNOVATIONS SP. Z O.O. Global B.V. and its affiliate(s).
// All rights reserved.
//
// This software and other materials contain proprietary information
// controlled by CONQUER INNOVATIONS SP. Z O.O. and are protected by applicable copyright legislation.
// Any use and utilization of this software and other materials and
// disclosure to any third parties is conditional upon having a separate
// agreement with CONQUER INNOVATIONS SP. Z O.O. for the access, use, utilization or disclosure of this
// software. In the absence of such agreement, the use of the software is not
// allowed.
// The creator, author and originator of the code in the current file: Michał Pawłowski
//////////////////////////////////////////////////////////////////////////////////
<template>
  <b-modal
      v-model="visible"
      title=""
      size="xl"
      hide-footer
  >
    <CommonTableImportForm
        title="Import danych zamówienia"
        importType="package-order-items"
        mode="submit"
        :fieldDefinitions="concatFields"
        @onSaved="handleSuccess"
        :meta="{orderGroupGuid: orderGroupGuid}"
        :identifierKeys="['guid','centralProductCartReference','bloz','ean']"
    />
  </b-modal>
</template>

<script>

import CommonTableImportForm from "@/components/widgets/CommonTableImportForm.vue";

export default {
  name: "PackageOrderItemImportWrapper",
  components: {CommonTableImportForm},
  props: {
    additionalFields: {
      type: Array,
      required: false
    },
    orderGroupGuid: {
      type: String,
      required: true
    }
  },
  emits: ['onImportSuccess', 'onClose'],
  data() {
    return {
      visible: false,
      concatFields:[],
      fields: [
        {key: "guid", label: "GUID", required: false, type: "string"},
        {key: "drugstoreClientId", label: "ID apteki", required: false, type: "string"},
        // {key: "listIndex", label: "Indeks na liście", required: false, type: "number"},// changing listIndex has no usage scenarios
        {key: "name", label: "Nazwa", required: false, type: "string"},
        {key: "bloz", label: "BLOZ", required: false, type: "string"},
        {key: "ean", label: "EAN", required: false, type: "string"},
        {key: "barcode", label: "Kod kreskowy", required: false, type: "string"},
        {key: "groupGuid", label: "GUID grupy", required: false, type: "string"},
        {key: "centralBloz", label: "Centralny BLOZ", required: false, type: "string"},
        {key: "amount", label: "Ilość", required: false, type: "number", defaultValue: 0.0, description: "Domyślnie 0.00"},
        {key: "discount", label: "Rabat", required: false, type: "number", defaultValue: 0.0, description: "Domyślnie 0.00"},
        {key: "notifications", label: "Uwagi", required: false, type: "string"},
        // {key: "isLocalSurplus", label: "Lokalna nadwyżka", required: false, type: "boolean", defaultValue: false, description: "Domyślnie: Nie"},
        {key: "offerPrice", label: "Cena ofertowa", required: false, type: "number"},
        // {key: "centralProductGuid", label: "GUID produktu centralnego", required: false, type: "string"},
        {key: "centralProductCartReference", label: "CKT", required: false, type: "string"},
        // {key: "sellingTax", label: "Vat", required: false, type: "number"}, // this is taken from product cart reference
        // {key: "amountToOrderCalcAlgorithm", label: "Algorytm wyliczania ilości", required: false, type: "string"}, // this will be set autmomatically by calculations algorithm
        // {key: "suggestedAmount", label: "Sugerowana ilość", required: false, type: "number"}, // this is calculated by algorithms,shound not be editable by user
        {key: "drugstoreSuggestedAmount", label: "Sugerowana ilość apteki", required: false, type: "number"},
        {key: "logisticMinAmountPerOrder", label: "Min. ilość logistyczna na zamówienie", required: false, type: "number"},
        {key: "logisticMinAmountPerDrugstore", label: "Min. ilość logistyczna na aptekę", required: false, type: "number"}
      ]
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    handleSuccess() {
      this.visible = false;
      this.$emit('onImportSuccess');
    }
  },
  watch: {
    visible(val) {
      if(!val) {
        this.$emit('onClose');
      }
    }

  },

  created() {
    console.log("this.additionalFields:", this.additionalFields);
    this.concatFields = this.fields.concat(this.additionalFields);
  }
};
</script>
